import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integrationhome',
  templateUrl: './integrationhome.component.html',
  styleUrls: ['./integrationhome.component.scss']
})
export class IntegrationHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
